import { Outlet, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Sidebar } from './Sidebar';
import { MobileNav } from './MobileNav';
import { TopBar } from './TopBar';
import { ChatFAB } from '../chat/ChatFAB';
import { useAlerts } from '../../hooks/useAlerts';

const PAGE_TITLES: Record<string, string> = {
  '/dashboard':      'Dashboard Ejecutivo',
  '/monitoring':     'Monitoreo en Tiempo Real',
  '/alerts':         'Gestión de Alertas',
  '/drivers':        'Conductores',
  '/vehicles':       'Vehículos',
  '/logbook':        'Novedades',
  '/expenses':       'Gastos',
  '/trips':          'Viajes',
  '/my-performance': 'Mi Desempeño',
  '/admin':          'Administración',
  '/reports':        'Reportes e Histórico',
};

export function AppShell() {
  const { criticalCount } = useAlerts();
  const location = useLocation();
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  const pageTitle = PAGE_TITLES[location.pathname] ?? 'Paitron Radar';

  useEffect(() => {
    document.title = `${pageTitle} | Paitron Radar`;
  }, [pageTitle]);

  useEffect(() => {
    const onOnline  = () => setIsOnline(true);
    const onOffline = () => setIsOnline(false);
    window.addEventListener('online',  onOnline);
    window.addEventListener('offline', onOffline);
    return () => {
      window.removeEventListener('online',  onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }, []);

  return (
    <div className="app-shell">
      {/* FE-13 retiró de aquí el toast de "novedad en tiempo real". Nunca lo
          fue: vivía en un useState de la pestaña, así que solo se disparaba si
          la novedad se registraba en esa MISMA sesión — jamás mostró la de
          otra persona. Firestore proyecta `vehicles-live` y `alerts-live`, y
          nada más: un canal en vivo para novedades exige backend y está
          anotado como pendiente. El supervisor las ve en Novedades. */}
      <Sidebar criticalCount={criticalCount} />
      <div className="app-shell__main">
        <TopBar
          title={pageTitle}
          criticalCount={criticalCount}
          isOnline={isOnline}
        />
        <main className="app-shell__content">
          <Outlet />
        </main>
      </div>
      {/* Bottom tab bar — solo visible bajo el breakpoint mobile (CSS) */}
      <MobileNav criticalCount={criticalCount} />
      {/* Global Chat FAB */}
      <ChatFAB />
    </div>
  );
}
